export const ACCESS_TYPE = 'ws'; // ws or sse
export const APP_KEY = ''; // 体验机器人的appkey
